/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AdditionalServiceVo } from './AdditionalServiceVo';
import {
    AdditionalServiceVoFromJSON,
    AdditionalServiceVoFromJSONTyped,
    AdditionalServiceVoToJSON,
    AdditionalServiceVoToJSONTyped,
} from './AdditionalServiceVo';

/**
 * 
 * @export
 * @interface OrderDetailUpdateAdditionalServiceVo
 */
export interface OrderDetailUpdateAdditionalServiceVo {
    /**
     * 支付方式 1：自动结算 2：手动结算
     * @type {number}
     * @memberof OrderDetailUpdateAdditionalServiceVo
     */
    paymentType?: number;
    /**
     * 附加服务列表
     * @type {Array<AdditionalServiceVo>}
     * @memberof OrderDetailUpdateAdditionalServiceVo
     */
    additionalServiceIds?: Array<AdditionalServiceVo>;
    /**
     * 商品验收前确认要求项
     * @type {string}
     * @memberof OrderDetailUpdateAdditionalServiceVo
     */
    requireBeforeAccept?: string;
}

/**
 * Check if a given object implements the OrderDetailUpdateAdditionalServiceVo interface.
 */
export function instanceOfOrderDetailUpdateAdditionalServiceVo(value: object): value is OrderDetailUpdateAdditionalServiceVo {
    return true;
}

export function OrderDetailUpdateAdditionalServiceVoFromJSON(json: any): OrderDetailUpdateAdditionalServiceVo {
    return OrderDetailUpdateAdditionalServiceVoFromJSONTyped(json, false);
}

export function OrderDetailUpdateAdditionalServiceVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderDetailUpdateAdditionalServiceVo {
    if (json == null) {
        return json;
    }
    return {
        
        'paymentType': json['paymentType'] == null ? undefined : json['paymentType'],
        'additionalServiceIds': json['additionalServiceIds'] == null ? undefined : ((json['additionalServiceIds'] as Array<any>).map(AdditionalServiceVoFromJSON)),
        'requireBeforeAccept': json['requireBeforeAccept'] == null ? undefined : json['requireBeforeAccept'],
    };
}

export function OrderDetailUpdateAdditionalServiceVoToJSON(json: any): OrderDetailUpdateAdditionalServiceVo {
    return OrderDetailUpdateAdditionalServiceVoToJSONTyped(json, false);
}

export function OrderDetailUpdateAdditionalServiceVoToJSONTyped(value?: OrderDetailUpdateAdditionalServiceVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paymentType': value['paymentType'],
        'additionalServiceIds': value['additionalServiceIds'] == null ? undefined : ((value['additionalServiceIds'] as Array<any>).map(AdditionalServiceVoToJSON)),
        'requireBeforeAccept': value['requireBeforeAccept'],
    };
}

